import { Box } from '@mui/system';

const ButtonBox = ({ children, marginRight, sx }) => {

    marginRight = marginRight || '1rem';

    return (
        <Box sx={{ 
            display: 'flex',
            justifyContent: 'space-between',
            '& > *:not(:last-child)': { marginRight: marginRight },
            ...sx
        }}>
            {children}
        </Box>
    );
};

export default ButtonBox;
